import { AddressForm } from "@/components/address/AddressForm";
import { useTranslation } from "react-i18next";
import { AgentType } from "../../../enums";

interface Props {
  agentType: "NATURAL" | "SELF_EMPLOYED" | "LEGAL";
  hasServiceAddress?: boolean;
  hasCorrespondenceAddress?: boolean;
}

export const AgentAddressesFormPart = ({ agentType, hasCorrespondenceAddress, hasServiceAddress }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <AddressForm
        formItemsNamePath={["address"]}
        required
        label={agentType === AgentType.LEGAL ? t("agent.attrs.addressLongPO") : t("agent.attrs.addressLong")}
      />

      <AddressForm
        formItemsNamePath={["serviceAddress"]}
        label={
          agentType === AgentType.SELF_EMPLOYED ? t("agent.attrs.serviceAddressFOP") : t("agent.attrs.serviceAddress")
        }
        hasInitialAddress={hasServiceAddress}
      />

      <AddressForm
        formItemsNamePath={["correspondenceAddress"]}
        label={t("agent.attrs.correspondenceAddress")}
        hasInitialAddress={hasCorrespondenceAddress}
      />
    </>
  );
};
